import * as React from "react";
import { cn } from "@babackapp/customer-ui/lib/utils";

interface CustomerUiProviderProps {
  children: React.ReactNode;
  className?: string;
}

export function CustomerUiProvider({ children, className }: CustomerUiProviderProps) {
  return (
    <div className={cn("cui", className)}>
      {children}
    </div>
  );
}
